import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SequenceMenu } from '@sequencehq/core-components'
import { useNotifications } from '@sequencehq/core-components'

const useDuplicateQuoteTemplate = (props: {
  quoteTemplateId: string
  onSuccess?: (newQuoteTemplateId: string) => void
}) => {
  const { displayPromiseNotification } = useNotifications()

  return {
    duplicateQuoteTemplate: async () => {
      try {
        const duplicatedQuoteTemplateRes = await displayPromiseNotification(
          dashboard20240730Client.postDuplicateQuoteTemplate({
            id: props.quoteTemplateId
          }),
          {
            loading: 'Duplicating template',
            success: 'Template duplicated',
            error: 'Failed to duplicate template'
          }
        )

        if (
          duplicatedQuoteTemplateRes.error ||
          !duplicatedQuoteTemplateRes.data
        ) {
          return false
        }

        props.onSuccess?.(duplicatedQuoteTemplateRes.data.template.id)
        return true
      } catch {
        return false
      }
    }
  }
}

export const DuplicateQuoteTemplateMenuItem = (props: {
  quoteTemplateId: string
  disabled?: boolean
  onSuccess?: (newQuoteTemplateId: string) => void
}) => {
  const { duplicateQuoteTemplate } = useDuplicateQuoteTemplate({
    quoteTemplateId: props.quoteTemplateId,
    onSuccess: props.onSuccess
  })
  return (
    <SequenceMenu.Item
      uuid="duplicate-quote-template"
      label="Duplicate template"
      data-testid={`quoteTemplates.${props.quoteTemplateId}.menuItem.duplicate`}
      isDisabled={props.disabled}
      onClick={duplicateQuoteTemplate}
    />
  )
}
